import React from 'react';
import { MapPin } from 'lucide-react';
import { offices } from '../mock/mock';

export default function Offices() {
  return (
    <section
      id="offices"
      className="relative py-24 px-5 md:px-8"
      style={{ background: 'linear-gradient(180deg, #fbf3e2, #f4e6c8, #fbf3e2)' }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Ribbon title */}
        <div className="flex justify-center">
          <div
            className="reveal px-10 py-3 rounded-md"
            style={{
              background: 'linear-gradient(90deg, #7c130f, #a71c14, #7c130f)',
              border: '1.5px solid #d9a63b',
              boxShadow: '0 8px 26px rgba(124,19,15,0.3)',
            }}
          >
            <h2 className="font-display font-bold tracking-[0.15em] text-[#f2d68a] text-2xl md:text-3xl">
              OUR OFFICES
            </h2>
          </div>
        </div>
        <p className="reveal font-body italic text-center text-[#7c4a20] text-lg md:text-xl mt-5" data-delay="120">
          Visit us across three sacred cities for in-person guidance.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mt-14">
          {offices.map((o, i) => (
            <div
              key={o.id}
              className="reveal group rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-2"
              data-delay={i * 150}
              style={{
                background: 'linear-gradient(180deg, #fffaf0, #f6e9cd)',
                border: '1.5px solid #e2c887',
                boxShadow: '0 12px 34px rgba(124,19,15,0.1)',
              }}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={o.image}
                  alt={o.city}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{ filter: 'sepia(0.25) saturate(1.05)' }}
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(124,19,15,0.05) 0%, rgba(90,13,10,0.55) 100%)',
                  }}
                />
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <MapPin className="text-[#f2d68a] drop-shadow-lg" size={26} strokeWidth={2.2} />
                  <span className="font-display font-bold text-[#fff8e7] text-2xl drop-shadow-lg">
                    {o.city}
                  </span>
                </div>
              </div>
              <div className="p-6 text-center">
                <p className="font-heading tracking-wide uppercase text-[#a4761b] text-xs">
                  {o.subtitle}
                </p>
                <div className="ornament-line w-16 mx-auto my-3" />
                <p className="font-body text-[#5a3a1c] text-lg">{o.desc}</p>
                <p className="font-body text-[#8a6535] text-base mt-2 leading-snug flex items-start justify-center gap-1.5 max-w-[16rem] mx-auto text-center">
                  <MapPin size={15} className="mt-1 shrink-0 text-[#a4761b]" />
                  <span>{o.address}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
